import * as _ from "lodash";

import { SubFormDefinition } from "../../../../../../../../utils/forms/components/FormSet";
import buildFormGridFields from "../../../../../../../../utils/forms/builders/build-form-grid-fields";
import { TERMINAL_GROUP_DEFINITION } from "./TerminalGroups.constants";
import buildSchemaCompliantDefinition from "../../../../../../../../utils/forms/builders/build-schema-compliant-definition";

/* Load Constants */
import { getNewGeneratedId, uuidv4 } from "../../../../../../../../utils/utils";

const terminalSubform = _.memoize(
    ({ schema, groupsConfig }): SubFormDefinition[] => {
        const schemaItems = schema.items;
        schemaItems.properties["name"]["unique"] = groupsConfig.map(
            group => group.name
        );

        const formDefinition = buildSchemaCompliantDefinition(
            schemaItems,
            TERMINAL_GROUP_DEFINITION
        );

        return [
            {
                formType: "terminalGroup",
                addLabel: "Add",
                emptyValue: {
                    uuid: uuidv4(),
                    id: getNewGeneratedId("term", groupsConfig),
                    name: "",
                    description: null
                },
                fields: buildFormGridFields(schemaItems, formDefinition)
            }
        ];
    }
);

export default terminalSubform;
